
import { cachedAPIWrapper, getCachedAPIResponse } from "../apiCaching/apiWrapper";
import { apiConfig } from "../config/apiConfig";
import { toggleHoursOfOperation } from "../util/hours_operation";
import { loadHereMapScripts } from "../util/share";
const wktParser = require('terraformer-wkt-parser');
export class AreaWeServe{
    public franchiseWebLocationId: any;
    private mapContainer: HTMLElement;
    private areaContainer: HTMLElement | null;
    public wkts: string[] = [];
    public mapType: string = "";
    private centroid: string = "";
    private correlationId: string = "";
    public franchiseId: any;
    private zoom_Level:any;
    private static instance: AreaWeServe;
    private counter: boolean = false;
    private initialized: boolean = false;

    /**
     * Static async factory method to create and initialize AreaWeServe instance
     * Use this method when you need the async initialization to complete
     */
    public static async create(): Promise<AreaWeServe> {
        if (!AreaWeServe.instance) {
            AreaWeServe.instance = new AreaWeServe();
            await AreaWeServe.instance.initialize();
        }
        return AreaWeServe.instance;
    }

    /**
     * Synchronous singleton getter - returns instance without async initialization
     * Use this only when you don't need the map data immediately
     */
    public static getInstance(): AreaWeServe {
        AreaWeServe.instance ??= new AreaWeServe();
        return AreaWeServe.instance;
    }

    private constructor() {
        const transactionID = sessionStorage.getItem('corelationID');
        const sessionID = sessionStorage.getItem('sessionID');
        this.correlationId = `correlationId=${transactionID}&sessionId=${sessionID}`;
        const localWebID = localStorage.getItem("franchiseWebLocationId");
        const webID = document.getElementById('weblocationId') as HTMLInputElement;
        this.franchiseWebLocationId = webID?.value ? webID?.value : localWebID;
        this.zoom_Level = Number((document.getElementById('map-zoom-level') as HTMLInputElement)?.value);
        this.areaContainer = document.querySelector(".area-serve-container");
        this.mapContainer = document.querySelector(".map-img-box") as HTMLElement;
        this.counter = false;
        if (this.areaContainer) {
            this.loadCities();
       
            const serveHoursDiv = this.areaContainer.querySelector('.serve-hours');
            if (serveHoursDiv) {
               this.init();
            }
        }
        
        if (this.franchiseWebLocationId) {
            this.getCityData();
        }
        // this.initMap();
    }

    /**
     * Private async initialization method
     * Called by create() to handle async operations
     */
    private async initialize(): Promise<void> {
        if (this.initialized) return;
        
        if (this.areaContainer) {
            await this.getWellKnownText();
        }
        
        this.initialized = true;
    }

    init() {
        toggleHoursOfOperation('.area-serve-text-section .serve-hours', '.area-serve-text-section .serve-hours-list', '.serve-hours-list li');
    }

    public loadCities(){
        const listElement = document.querySelector(".city-list")as HTMLUListElement;
        const readMoreButton = document.getElementById("readMoreListButton") as HTMLButtonElement;
        if (window.innerWidth < 1024) {
            if (listElement) {
                const listItems = Array.from(listElement.children) as HTMLLIElement[];
                const maxItems = 20;
                
                // Only show read more button if there are more than maxItems
                if (readMoreButton && listItems.length > maxItems) {
                    // Hide excess list items
                    for (let i = maxItems; i < listItems.length; i++) {
                        listItems[i].style.display = "none";
                    }
                    readMoreButton.classList.remove("hidden");
                    readMoreButton.style.display = '';
                    // Event listener for read more/less button
                    readMoreButton.addEventListener("click", function() {
                        if (readMoreButton.textContent === "Read more...") {
                            for (let i = maxItems; i < listItems.length; i++) {
                                listItems[i].style.display = "list-item";
                            }
                            readMoreButton.textContent = "Read less...";
                        } else {
                            for (let i = maxItems; i < listItems.length; i++) {
                                listItems[i].style.display = "none";
                            }
                            readMoreButton.textContent = "Read more...";
                        }
                    });
                }
                else{
                    readMoreButton.classList.add("hidden");
                    readMoreButton.style.display = 'none';
                }
            }
        }
    }
    public multipleWkts() {
        this.wkts.forEach((wkt) => {
            if (this.mapType === "polygon") {
                this.initGMapPolygon();
            }else{
                this.initGMap(wkt);
            }
        });
    }

    private initGMapPolygon() {
        let map: google.maps.Map;
        
        let minX: number, minY: number, maxX: number, maxY: number;

        const addPoints = (ptsArray: google.maps.LatLng[], data: string) => {
            const pointsData = data.split(",");
            let str = "";
            for (let i = 0; i < pointsData.length; i++) {
                const xy = pointsData[i].trim().split(" ");
                const pt = new google.maps.LatLng(Number.parseFloat(xy[1]), Number.parseFloat(xy[0]));
                str = str + ", " + xy[1] + " " + xy[0];
                ptsArray.push(pt);

                if (i === 0) {
                    minX = maxX = Number.parseFloat(xy[1]);
                    minY = maxY = Number.parseFloat(xy[0]);
                } else {
                    minX = Math.min(Number.parseFloat(xy[1]), minX);
                    minY = Math.min(Number.parseFloat(xy[0]), minY);
                    maxX = Math.max(Number.parseFloat(xy[1]), maxX);
                    maxY = Math.max(Number.parseFloat(xy[0]), maxY);
                }
            }
        };

        const createPoly = (wkt: string) => {
            const regex = /\(([^()]+)\)/g;
            const Rings: string[] = [];
            let results;
            while ((results = regex.exec(wkt))) {
                Rings.push(results[1]);
            }

            const ptsArray: google.maps.LatLng[] = [];
            let maxLen = 0;
            let j = 0;

            for (let i = 0; i < Rings.length; i++) {
                if (maxLen <= Rings[i].length) {
                    maxLen = Rings[i].length;
                    j = i;
                }
            }

            addPoints(ptsArray, Rings[j]);

            const poly = new google.maps.Polygon({
                paths: ptsArray,
                strokeColor: "#FF0000",
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillColor: "#1E90FF",
                fillOpacity: 0.35,
            });

            return poly;
        };

        this.wkts.forEach((wkt) => {
            const poly = createPoly(wkt);
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    // Use the user's location as the center
                    const zoomLevel = this.zoom_Level ? this.zoom_Level : 8.8;
                    const myOptions: google.maps.MapOptions = {
                        zoom: zoomLevel,
                        center: new google.maps.LatLng(37.7749, -122.4194),
                        zoomControl: true,
                        scaleControl: true,
                    };

                    map = new google.maps.Map(this.mapContainer, myOptions);
                    const bounds = new google.maps.LatLngBounds();
                    poly.getPath().forEach((path) => {
                        bounds.extend(path);
                    });
                    map.fitBounds(bounds);
                    let listener = google.maps.event.addListener(map, "idle", function() { 
                        map.setZoom(zoomLevel); 
                        google.maps.event.removeListener(listener); 
                   });
                    poly.setMap(map);
                },
                (error) => {
                    const centerLatitude = (maxX + minX) / 2;
                    const centerLongitude = (maxY + minY) / 2;
                    const zoomLevel = this.zoom_Level ? this.zoom_Level : 8.8;

                    const myOptions: google.maps.MapOptions = {
                        zoom: zoomLevel,
                        center: new google.maps.LatLng(centerLatitude, centerLongitude),
                        zoomControl: true,
                        scaleControl: true,
                    };
                    map = new google.maps.Map(this.mapContainer, myOptions);
                    const bounds = new google.maps.LatLngBounds();
                    poly.getPath().forEach((path) => {
                        bounds.extend(path);
                    });
                    map.fitBounds(bounds);
                    let listener = google.maps.event.addListener(map, "idle", function() { 
                        map.setZoom(zoomLevel); 
                        google.maps.event.removeListener(listener); 
                   });
                    poly.setMap(map);
                }
            );
        });
    }

    private getCityData(): void {
        const request = apiConfig.fullAttribute + this.franchiseWebLocationId;

        const updateContent = (element: HTMLElement | null, content: string) => {
            if(element) {
                element.textContent = content;
            }
        }

        //This function handles the updation of the address
        const updateAddressContent = (resp: any, filterFlag: any) => {
            const { address, address2, state, country, city, zip, displayAddressSwitch } = resp;
            const checkForDOMElement = document.getElementById("show-address");
            if(!filterFlag.disable_location_address && checkForDOMElement) {
                const areaWeServe = document.querySelector('.area-serve-title') as HTMLElement;
                if(areaWeServe){
                    areaWeServe.innerHTML+= `<p class="title-sub-text"></p>`;
                }
                const addressContainer = document.querySelector('.area-serve-title .title-sub-text') as HTMLElement;
                if(displayAddressSwitch) {
                    updateContent(addressContainer, `${address}${address2 ? ', ' + address2 : ''} ${city}, ${state} ${zip}, ${country}`);
                } else {
                    updateContent(addressContainer, `${city}, ${state} ${zip}, ${country}`);
                }
            }
        }
        
        //This updates the h2 title
        const updateTitleContent = (resp: any) => {
            const { locationDoingBusinessAs } = resp;
            const addressTitle = document.querySelector('.area-serve-title .title-heading') as HTMLElement;
            if(!addressTitle?.textContent && locationDoingBusinessAs) {
                updateContent(addressTitle, locationDoingBusinessAs);
            }
        }
        
        cachedAPIWrapper(request)
        .then((resp: any) => {
            const brandSpecificData = localStorage.getItem("brandDetails");
            if(brandSpecificData){
                const filterFlag = JSON.parse(brandSpecificData);
                updateAddressContent(resp, filterFlag);
            }
            updateTitleContent(resp);
        })
        .catch((err) => {
            console.error(err)
        });
    }

    
    private async getWellKnownText(): Promise<void> {
        await loadHereMapScripts();
        if(this.counter) {
            return;
        }
        if (!this.franchiseWebLocationId) {
            // FranchiseWebLocationId not available, do nothing
            return;
        }
        try {
            const data = await cachedAPIWrapper(apiConfig.WebLocationsAPI);
            if (!data) {
                // No location data, do nothing
                return;
            }
            this.franchiseId = await this.findFranchiseIdByWebLocationId(data, this.franchiseWebLocationId);           
            if (!this.franchiseId || this.franchiseId === null) {
                // Franchise ID invalid or null call again
                 setTimeout(() => {
                 this.getWellKnownText();
                 this.counter = true;
            }, 1000);
                return;
            }
            // Franchise ID is available, proceed
            const apiUrl = `${apiConfig.FranchiseTerritoriesAPI}&franchiseId=${this.franchiseId}`;
            getCachedAPIResponse(apiUrl)
                .then((result: any) => {
                    let territoryMapData:any;
                    result.franchiseTerritories.forEach((value: any) => {
                        if(value.franchiseWebLocationId === Number(this.franchiseWebLocationId) && value.comment.includes("website")){
                            territoryMapData =  value;
                        }
                    });
                    if (territoryMapData?.territoryBoundary?.wellKnownText) {
                        const wktData = territoryMapData.territoryBoundary.wellKnownText;
                        this.wkts.push(wktData);
                        this.mapType = wktData.split(" ")[0].toLowerCase();
                        this.centroid = territoryMapData.territoryBoundary.centroid;
                        this.multipleWkts();
                    } 
                    else{
                        console.log("No map data available");
                    }
                })
                .catch((error) => {
                    console.log("Error:", error);
                });
        } catch (error) {
            console.log("Fetch error:", error);
        }
    }


    async findFranchiseIdByWebLocationId(data: any, webLocationId: any) {
        if (!data?.length) return null;

        try {

            const fullAttrOnLoad = localStorage.getItem("fullAttrOnLoad");
            const contractNumber = fullAttrOnLoad ? JSON.parse(fullAttrOnLoad)?.contractNumber : null;

            if (!contractNumber) {
                    return await this.fetchAndStoreFullAttr(webLocationId, data);
            }

            return this.findFranchiseIdWithContractNumber(data, webLocationId, contractNumber);
            
        } catch (error) {
            console.error("Error finding franchise ID:", error);
            return null;
        }
     
    }

     private async fetchAndStoreFullAttr(webLocationId: any, data: any): Promise<any> {
        try {
            const response = await cachedAPIWrapper(`${apiConfig.GET_ATTRIBUTE_DATA}/${webLocationId}`);
            localStorage.setItem("fullAttrOnLoad", JSON.stringify(response));
            if (response?.contractNumber) {
                return this.findFranchiseIdWithContractNumber(data, webLocationId, response.contractNumber);
            }
            return this.findFranchiseIdWithoutContractNumber(data, webLocationId);
        } catch (error) {
            console.warn("Error fetching full attribute data:", error);
            return null;
        }
    }

    private findFranchiseIdWithoutContractNumber(data: any, webLocationId: any) {
        for (const item of data) {
            const franchiseDetails = item.franchiseDetails;
            for (const detail of franchiseDetails) {
                if (detail.franchiseWebLocationId == webLocationId) {
                    return item.franchiseId;
                }
            }
        }
        return null;
    }

    private findFranchiseIdWithContractNumber(data: any, webLocationId: any, contractNumber: string) {
        for (const item of data) {
            const franchiseDetails = item.franchiseDetails;
            for (const detail of franchiseDetails) {
                if (
                    detail.franchiseWebLocationId == webLocationId &&
                    detail.licenseNumber === contractNumber
                ) {
                    return item.franchiseId;
                }
            }
        }
        return null;
    }
    private initGMap(wkt:any){
        let geometry = wktParser.parse(wkt);
        let center = this.centroid.replace("POINT (", "").replace(')', "").split(" ");
        let data = {
            "type": "FeatureCollection",
            "features": [ {
                "type": "Feature",
                "properties": {
                    "fillColor": "#1E90FF"
                    },
                "geometry": geometry
            }]
        };
        let mapProp = {
            center: {lat: Number.parseFloat(center[1]), lng: Number.parseFloat(center[0])},
            zoom: this.zoom_Level ? this.zoom_Level : 8.8,
            zoomControl: true,
            scaleControl: true,
        };
        
        let map = new google.maps.Map(this.mapContainer, mapProp);
        map.data.addGeoJson(data);
        map.data.setStyle(function (feature:any) {

            return {
                fillColor: '#1E90FF',
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillOpacity: 0.35
            };
        });
        }
}
